// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"d2db9f36","777":"59db85c2"}[chunkId] + ".chunk.js";
};